import React, {useState} from 'react';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import {Actions as PAYROLLACTIONS} from '../../store/actions/payrollActions';
import {Actions as COMPANYACTIONS} from '../../store/actions/companyActions';
import { format } from 'date-fns'
import { InboxArrowDownIcon } from "@/icons/outline";

import Spinner from '../common/Spinner';
import { XMarkIcon } from '@heroicons/react/20/solid'

import cleanDeep from "clean-deep";

const TestConfirmationModal = ({
  salary,
  sendPayslips,
  closeModal,
  modalStatus,
  payslipCount,
  sending,
  sent,
  saveOption,
  companySettings,
}) => {
  const [attachPdf, setAttachPdf] = useState(false);

  const { register, handleSubmit, control, watch, setValue, reset } = useForm();

  if (!modalStatus){
    return null
  }

  const updatePreferences = (bool) => {
    saveOption({ ...companySettings, showTILModal: bool})
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)"}}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b" style={{padding: 0}}>
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button data-dismiss="modal" type="button" onClick={closeModal}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title" style={{padding:"15px 20px"}}>
                Test Submissions
              </h3>
            </div>
            <div className="modal-body">
              <div className="clearfix"></div>
              Would you like to be prompted for a Test Submission going forward? 
            </div>
            <div className="block-content" style={{padding: "0px 20px 1px"}}>
              {
                  sending && 
                  <Spinner 
                     style={{width: '2rem',height: '2rem', verticalAlign: 'middle',marginTop: 20}}
                     className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"/>
              }

              <div className="flex-auto buttons" style={{paddingBottom: 20}}>
                {
                  !sent && 
                  <button className="btn btn-success pull-right" type="submit" 
                    onClick={() =>  {//to be done
                        updatePreferences(true);
                        closeModal();
                      }
                    }
                  >
                    <InboxArrowDownIcon className="w-7 h-7 mr-3" style={{verticalAlign: "text-bottom"}}/>
                    Yes
                  </button>
                }
                {
                  sent && 
                  <div className="btn btn-success pull-right">
                    Yes
                  </div>
                }
                {
                  !sent && 
                  <button className="btn btn-success pull-left" type="submit"
                    onClick={() => {//to be done
                        updatePreferences(false);
                        closeModal();
                      }
                    }
                  >
                    <InboxArrowDownIcon className="w-7 h-7 mr-3" style={{verticalAlign: "text-bottom"}}/>
                    No
                  </button>
                }
                {
                  sent && 
                  <div className="btn btn-success pull-left">
                    No
                  </div>
                }
                <div className="clearfix"></div>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {

  const { employees } = state.payroll;
  const {sendPayslipModal} = state

  return {
    modalStatus: state.payroll.testConfirmationModal,
    companySettings: state.company.settings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(PAYROLLACTIONS.setTestConfirmationModal(false)),
  saveOption: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body, true))
});

export default connect(mapStateToProps, mapDispatchToProps)(TestConfirmationModal);
